import { PartAutoCompleteComponent } from './PartAutoCompleteComponent';

export default PartAutoCompleteComponent;
